import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { App } from "antd";
import { LOADING_SUBJECTS, SUBJECTS } from "../store/selectors";
import {
  getSubjects,
  deleteSubject as deleteSubjectService,
  getSubjectById as getSubjectByIdService,
} from "../services/subjects/subjects.service";
import {
  setLoading,
  setSubjects,
  deleteSubject as deleteSubjectAction,
} from "../store/slices/subject";

export const useSubjects = () => {
  // From App.useApp(): the static notification does not render under React 19.
  const { notification } = App.useApp();
  const dispatch = useDispatch();
  const subjects = useSelector(SUBJECTS);
  const loading = useSelector(LOADING_SUBJECTS);

  const fetchInfo = async () => {
    dispatch(setLoading(true));
    try {
      if (subjects?.length > 0) {
        setSubjects(subjects);
      } else {
        const subjectsResponse = await getSubjects();
        subjectsResponse && dispatch(setSubjects(subjectsResponse));
      }
      dispatch(setLoading(false));
    } catch (error: any) {
      dispatch(setLoading(false));
      notification["error"]({
        message: "Error",
        description:
          "La información no pudo ser cargada, por favor notifica éste error!",
        placement: "top",
        duration: 3,
      });
      throw new Error(error);
    }
  };

  const getSubjectById = async (id: number) => {
    try {
      const response = await getSubjectByIdService(id);
      return response;
    } catch (error: any) {
      notification["error"]({
        message: "Error",
        description:
          "La información no pudo ser cargada, por favor notifica éste error!",
        placement: "top",
        duration: 3,
      });
      throw new Error(error);
    }
  };

  const deleteSubject = async (id: number): Promise<boolean> => {
    dispatch(setLoading(true));
    try {
      await deleteSubjectService(id);
      dispatch(deleteSubjectAction(id));
      notification["success"]({
        message: "Éxito",
        description: "La asignatura fue eliminada exitosamente!",
        placement: "top",
        duration: 3,
      });
      dispatch(setLoading(false));
      return true;
    } catch (error: any) {
      dispatch(setLoading(false));
      notification["error"]({
        message: "Eliminación Erronea",
        description:
          error?.response?.data?.message || "La asignatura no pudo ser eliminada!",
        placement: "top",
        duration: 3,
      });
      return false;
    }
  };

  useEffect(() => {
    fetchInfo();
  }, []);

  return {
    loading,
    subjects,
    deleteSubject,
    getSubjectById,
  };
};
